import axios from "axios"

import { IsEmptyString } from "../Components/GeneralFunctions"

const cPhoneBaseApi = "https://useraccount.cloudcti.nl/phone/api/" //TEMP!!!!

export async function PhoneApiMakeCall(aSecurityToken, aNumber, aAllowRedirect) 
{
    try
    {
        await axios.post(cPhoneBaseApi + "callcontrol/makecall",   
        {
            "Number": aNumber
        },
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })
        return null
    }
    catch (ex)
    {
        if (aAllowRedirect && (ex.response?.request?.status === 303) && !IsEmptyString(ex.response?.data?.Exception?.Message))
        {
            //Local connections, such as Teams, use a redirecturl in a SeeOther response
            //This is done if the phone api suggests a url that the user should be opened in a new window locally
            window.open(ex.response.data.Exception.Message)
            return null
        }
        else
        {
            return(ex)
        }
    }
}

export async function PhoneApiGetPhoneSettings(aSecurityToken) 
{
    try
    {
        return await axios.get(cPhoneBaseApi + "settings/phone",  
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })
    }
    catch (ex)
    {
        return(ex)
    }
}

export async function PhoneApiSetPhoneSettings(aSecurityToken, aPhoneSettings) 
{
    console.log("PhoneApiSetPhoneSettings",aPhoneSettings)
    return await axios.put(cPhoneBaseApi + "settings/phone",  
    {
        PhoneSettings: aPhoneSettings
    },
    {
        headers: {
            Authorization: "Bearer " + aSecurityToken,
            Accept: "application/json"
        }
    })
}

export async function PhoneApiSubscribe(aSecurityToken) 
{
    try
    {
        return await axios.post(cPhoneBaseApi + "subscription", {},
        {
            headers: {
                Authorization: "Bearer " + aSecurityToken,
                Accept: "application/json"
            }
        })
    }
    catch (ex)
    {
        return(ex)
    }
}